import { SyncOutlined } from '@ant-design/icons';
import Tooltip from 'antd/es/tooltip';
import { PermissionContext } from 'components/Global/AuthLayout';
import Buttons from 'components/Global/Buttons';
import { useContext } from 'react';
import styles from './index.module.scss';

type headerProps = {
	sidebarDrawerOpen: () => void;
	isLoading: boolean;
	fetchLatestNapsaData :any;
};

const NapsaHeader = ({
	sidebarDrawerOpen,
	isLoading,
	fetchLatestNapsaData,
}: headerProps) => {
	const permissionContext = useContext(PermissionContext);
	const isAdd = permissionContext.allowedPermissions.includes(
		'Add_Statutory_Components'
	);
	const buttonTitle = 'Add NAPSA';
	const buttons = [
		{
			text: buttonTitle,
			isLoading: false,
			className: 'btn-blue',
			isSubmit: true,
			onclick: () => {
				sidebarDrawerOpen();
			},
			disabled: isLoading,
		},
	];
	return (
		<div className={styles['napsa-header']}>
			<p>NAPSA</p>
			{isAdd && (
				<div className={styles['napsa-header__buttons']}>
					<Tooltip title="Refresh all the NAPSA">
						<SyncOutlined
							style={{
								fontSize: '20px',
								cursor: isLoading ? 'not-allowed' : 'pointer',
								color: '#584495',
								transition: 'transform 0.3s',
								marginRight: '10px',
							}}
							onClick={
								!isLoading ? fetchLatestNapsaData : undefined
							}
						/>
					</Tooltip>
					<Buttons buttons={buttons} />
				</div>
			)}
		</div>
	);
};

export default NapsaHeader;
